var fagtek = {} || fagtek;
var espresso = espresso || {},
    ga = ga || {};
( function () {
    'use strict';
    jQuery( function () {
        fagtek.init();
    } );
    fagtek = {
        init: function () {
            fagtek.frontpageWrapper.init();
            fagtek.vilkaarogbetingelser.init();
            fagtek.vilkaarogbetingelser.init();
            fagtek.scrollToTechnician.init();
            espresso.newsletterpopup.highlightPopup();
            espresso.newsletterpopupgatracking();
            jQuery( '.validation-state' ).tooltip();
            espresso.dealersearch.init();
            // espresso.newsletterpopup.form.mailchimp();
            // espresso.newsletterpopup.popup.container();
        },
        frontpageWrapper: {
            init: function () {
                fagtek.frontpageWrapper.calculateTopMargin();
                jQuery( window ).resize( function () {
                    fagtek.frontpageWrapper.calculateTopMargin();
                    console.log( 'resize' );
                } );
            },
            calculateTopMargin: function () {
                jQuery( window ).ready( function () {
                    if ( jQuery( window ).width() > 769 ) {
                        var leadheight = jQuery( '.frontpage-wrapper .lead' ).height(),
                            paddingTop = parseInt( jQuery( '.container-frontpage' ).css( 'padding-top' ) ),
                            marginBottom = parseInt( jQuery( '.container-frontpage .lead' ).css( 'margin-bottom' ) );
                        fagtek.frontpageWrapper.calculate( leadheight, paddingTop, marginBottom );
                    }
                    else {
                        fagtek.frontpageWrapper.calculate( 0, 0, 0 );
                    }
                } );
            },
            calculate: function ( leadheight, paddingTop, marginBottom ) {
                var negativeMarginWrapper = -leadheight - paddingTop - marginBottom,
                    sliderBottomSpacing = +leadheight + paddingTop + marginBottom + 50;
                fagtek.frontpageWrapper.applyTopMarginToStylesheet( negativeMarginWrapper, sliderBottomSpacing );
            },
            applyTopMarginToStylesheet: function ( negativeMarginWrapper, sliderBottomSpacing ) {
                jQuery( '.carousel-indicators.carousel-frontpage-indicators' ).css( {
                    'z-index': '1'
                } );
                jQuery( '.e-wrapper.frontpage-wrapper' ).css( 'margin-top', negativeMarginWrapper );
                jQuery( '.frontpage-slider .carousel .carousel-indicators' ).css( 'bottom', sliderBottomSpacing );
            }
        },
        vilkaarogbetingelser: {
            init: function () {
                fagtek.vilkaarogbetingelser.open();
            },
            open: function () {
                var vilkaarBetingelserLink = jQuery( '.Jegaccepterervilkaarogbetingelserne > div > small > a' );
                vilkaarBetingelserLink.on( 'click', function () {
                    jQuery( '.Vilkaarogbetingelser' ).css( {
                        'height': 'auto',
                    } );
                } );
            }
        },
        scrollToTechnician: {
            init: function () {
                if ( jQuery( '#js-e-map-list' ).length === 1 ) {
                    fagtek.scrollToTechnician.bindLink();
                }
            },
            bindLink: function () {
                jQuery( '.js-e-map-list-item-name' ).on( 'click', function ( event ) {
                    console.log('click');
                    event.preventDefault();
                    var paragraphLink = jQuery(this).data( 'paragraph-link-id' );
                    var parentDiv = jQuery( '#' + paragraphLink ).closest( 'div' );
                    espresso.util.scroll.toPosition( parentDiv.position().top - 90);

                } );
            }
        }
    };
    espresso.newsletterpopup.highlightPopup = function () {
        // Fixed button
        jQuery( '.e-newsletter-popup-teaser a, .newsletter-signup-confirmation-message' ).on( 'click', function () {
            jQuery( '.newsletter-darken-background' ).css( {
                'opacity': '0.8',
                'z-index': '1010',
                'display': 'block'
            } );
            jQuery( '.e-newsletter-popup-container' ).css( {
                'bottom': '50%'
            } );
        } );
        jQuery( '.newsletter-darken-background, .e-newsletter-popup-close' ).on( 'click', function () {
            jQuery( '.newsletter-darken-background' ).css( {
                'opacity': '0',
                'z-index': -100,
                'display': 'none'
            } );
        } );
        jQuery( '#mc-embedded-subscribe-form' ).on( 'submit', function () {
            if ( jQuery( '.mc-field-group input.valid' ).length === 5 ) {
                jQuery( '.newsletter-darken-background' ).css( {
                    'opacity': '0',
                    'z-index': -100,
                    'display': 'none'
                } );
                jQuery( '.e-newsletter-popup-container' ).css( {
                    'bottom': '-732px'
                } );
            }
        } );
    };
    espresso.newsletterpopup.bindings = function ( jLargePopup, jOffset, popupTimer ) {
        jQuery( '.js-e-newsletter-popup-close' ).on( 'click', function ( event ) {
            event.preventDefault();
            clearTimeout( popupTimer );
            espresso.newsletterpopup.hidden( -( jLargePopup.height() + jLargePopup.find( 'img' ).height() ) );
        } );
        jQuery( 'body' ).on( 'click', function ( event ) {
            if ( jLargePopup.is( '.opened' ) === true ) {
                if ( jQuery( event.target ).parents( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ).length === 0 && !jQuery( event.target ).is( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ) ) {
                    espresso.newsletterpopup.hidden( -( jLargePopup.height() + jLargePopup.find( 'img' ).height() ) );
                    clearTimeout( popupTimer );
                }
            }
        } );
        jQuery( '.js-e-newsletter-popup-teaser' ).find( '.e-newsletter-toggle-view' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', '50%' );
            jQuery( '.js-e-newsletter-popup-teaser' ).removeClass( 'opened' ).addClass( 'closed' ).css( 'display', 'none' );
        } );
        jQuery( '.js-e-newsletter-popup-form-submit' ).on( 'click', function () {
            espresso.newsletterpopup.formHandler.validate();
        } );
        jLargePopup.find( 'input' ).on( 'keyup', function () {
            if ( jQuery( this ).val() ) {
                jQuery( this ).removeClass( 'error' );
            }
        } );
        jQuery( '.js-e-newsletter-teaser-close' ).on( 'click', function () {
            jQuery( '.js-e-newsletter-popup-teaser' ).removeClass( 'opened' ).addClass( 'closed' ).css( 'display', 'none' );
            espresso.newsletterpopup.setCookie( 'e-newsletterState', 'disabled' );
            console.log( 'test' );
        } );
    };
    espresso.newsletterpopup.hidden = function ( jHeight ) {
        jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'opened' ).addClass( 'closed' ).css( 'bottom', jHeight );
        jQuery( '.js-e-newsletter-popup-teaser' ).removeClass( 'closed' ).addClass( 'opened' ).css( 'display', 'block' );
        this.setCookie( 'e-newsletterState', 'hidden' );
    };
    espresso.newsletterpopupgatracking = function () {
        jQuery( '.newsletter-popup-form' ).data( 'validator' ).settings.submitHandler = function ( form ) {
            ga( 'send', 'event', 'Nyhedsbrevstilmelding', 'Popup' );
            form.submit();
        };
    };
    jQuery( '.pakke-bestilling, .fagtek-form-validate' ).validate();
    jQuery.extend( jQuery.validator.messages, {
        required: '<i class="icon-exclamation-sign validation-state"></i>'
    } );
    jQuery( '#mc-embedded-subscribe-form' ).validate( {
        debug: false,
        rules: {
            'FAG1': {
                required: function () {
                    return ( jQuery( '#mc-embedded-subscribe-form' ).find( 'input[name="FAG2"]' ).is( ':checked' ) ) ? false : true;
                }
            },
            'FAG2': {
                required: function () {
                    return ( jQuery( '#mc-embedded-subscribe-form' ).find( 'input[name="FAG1"]' ).is( ':checked' ) ) ? false : true;
                }
            }
        },
        groups: {
            fagDropdown: 'FAG1 FAG2'
        },
        messages: {
            'FAG1': {
                required: 'Vælg venligst mindst én af ovenstående.'
            },
            'FAG2': {
                required: 'Vælg venligst mindst én af ovenstående.'
            }
        },
        success: function ( label ) {
            label.remove();
        },
        errorPlacement: function ( error, element ) {
            // error = jQuery('<i id="' + error.attr('id') + '" class="error icon-exclamation-sign validation-state" for="' + error.attr('htmlFor') + '"></i>');
            // console.log(error);
            if ( element.attr( 'name' ) === 'FAG1' || element.attr( 'name' ) === 'FAG2' ) {
                console.log( error );
                error.appendTo( '.newsletterpopup-checkbox-errortext' );
                jQuery( 'label #fagDropdown-error.error' ).css( {
                    'display': 'block !important'
                } );
            }
            else {
                error.insertAfter( element );
            }
        }
    } );
    jQuery( '.collapse' ).collapse();
}() );
